import React from 'react';
import ReactDOM from 'react-dom';
import "@babel/polyfill";
import {HashRouter} from 'react-router-dom';
import './index.css';
import App from './App';

import {LocaleProvider} from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(<LocaleProvider locale={zhCN}><HashRouter><App /></HashRouter></LocaleProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
